export const samedayStatusConfig = {
  // Status mapping
  statusMapping: {
    // Normal Delivery Flow
    1: 'REGISTERED',    // Comandă înregistrată
    2: 'IN_TRANSIT',    // În curs de ridicare
    3: 'IN_TRANSIT',    // Colet ridicat
    4: 'IN_TRANSIT',    // În tranzit spre depozit
    5: 'IN_TRANSIT',    // În depozit
    6: 'IN_TRANSIT',    // În curs de livrare
    7: 'DELIVERED',     // Livrat

    // Failed Delivery Attempts
    8: 'FAILED',        // Livrare eșuată
    9: 'RETURNED',      // Retur în depozit

    // Cancellations and Issues
    15: 'CANCELED',     // Comandă anulată
    16: 'CANCELED',     // Comandă respinsă
    17: 'CANCELED',     // Comandă expirată

    // Locker/PUDO Services
    20: 'PENDING',      // În așteptare încărcare în easybox
    21: 'IN_TRANSIT',   // Încărcat în easybox
    22: 'DELIVERED',    // Ridicat din easybox
    23: 'FAILED',       // Încărcare eșuată în easybox
    24: 'CANCELED',     // Comandă anulată locker
  } as Record<number, 'REGISTERED' | 'IN_TRANSIT' | 'DELIVERED' | 'CANCELED' | 'FAILED' | 'RETURNED' | 'PENDING'>,

  // Romanian status labels
  statusLabels: {
    // Normal Delivery Flow
    1: 'Comandă înregistrată',
    2: 'În curs de ridicare',
    3: 'Colet ridicat',
    4: 'În tranzit spre depozit',
    5: 'În depozit',
    6: 'În curs de livrare',
    7: 'Livrat',

    // Failed Delivery Attempts
    8: 'Livrare eșuată',
    9: 'Retur în depozit',

    // Cancellations and Issues
    15: 'Comandă anulată',
    16: 'Comandă respinsă',
    17: 'Comandă expirată',

    // Locker/PUDO Services
    20: 'În așteptare încărcare în easybox',
    21: 'Încărcat în easybox',
    22: 'Ridicat din easybox',
    23: 'Încărcare eșuată în easybox',
    24: 'Comandă anulată locker'
  } as Record<number, string>,

  calculateDeliveryProgress: (statusId: number): number => {
    const progressMap: Record<number, number> = {
      1: 5,
      2: 15,
      3: 30,
      4: 45,
      5: 60,
      6: 85,
      7: 100,
      8: 85,
      9: 40,
      20: 70,
      21: 85,
      22: 100,
      23: 70
    };
    return progressMap[statusId] ?? 0;
  },

  // Status grouping
  getStatusGroup: (statusId: number): 'active' | 'completed' | 'failed' | 'cancelled' => {
    // Completed deliveries (successful delivery or locker pickup)
    if ([7, 22].includes(statusId)) return 'completed';

    // Failed deliveries (delivery attempts, returns, locker failures)
    if ([8, 9, 23].includes(statusId)) return 'failed';

    // Cancelled orders (all types of cancellations)
    if ([15, 16, 17, 24].includes(statusId)) return 'cancelled';

    // Active shipments
    return 'active';
  }
};
